
function getSrcSetPathOf(sourceImage) {
    return sourceImage.src + ' 1x' + (sourceImage.src2x ? ', ' + sourceImage.src2x + ' 2x' : '');
}

function getFallbackImageSrc() {
    return "data:image/gif;base64,R0lGODlhCgAOAIAAAAAAAOjo6CH5BAUKAAAALAAAAAAKAA4AAAIKjI+py+0Po5wUFQA7";
}

export default {
    getSrcSetPathOf,
    getFallbackImageSrc,
};
